import type { MetricInfo, StepPlanRepetitionMode } from '@az3fr/core';
import { memo } from 'react';

function SetsTableHeaderV2({
	metrics,
	repetitionMode,
	gridTemplateColumns,
}: {
	metrics: MetricInfo[];
	repetitionMode: StepPlanRepetitionMode;
	gridTemplateColumns: string;
}) {
	return (
		<div
			className="grid border-gray-200 border-b bg-gray-50 uppercase"
			style={{ gridTemplateColumns }}
		>
			{/* Set/Sets Column Header */}
			<span className="grid place-items-center p-2.5 font-medium text-gray-500 text-xs uppercase tracking-widest">
				{repetitionMode === 'explicit' ? 'Set' : 'Sets'}
			</span>

			{/* Metric Column Headers */}
			{metrics.map((metric: MetricInfo) => (
				<div key={metric.id} className="p-2.5 text-center">
					<span className="font-medium text-gray-500 text-xs uppercase tracking-widest">
						{metric.nameAbbreviation || metric.name}
					</span>
					{/* Hide unit for reps. @todo: probably better to have this in a config object for metrics */}
					{metric.canonicalName !== 'reps' && (
						<span className="ms-0.5 text-gray-400 text-xs">
							({metric.unitAbbreviation || metric.unit})
						</span>
					)}
				</div>
			))}
		</div>
	);
}

const MemoizedSetsTableHeaderV2 = memo(SetsTableHeaderV2);

export { MemoizedSetsTableHeaderV2 as SetsTableHeaderV2 };
